import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter,
} from '@angular/core';
import { ConfirmationFormService } from './confirmation-form.service';
import { ConfirmationWorkPlaceService } from './confirmation-work-place/confirmation-work-place.service';
import { ConfirmationIndexService } from './confirmation-index/confirmation-index.service';

import { Subscription } from 'rxjs/Subscription';
import { CONFIRMATION_SENT } from '../../shared/constants/application-status.constant';
import { TNK_TOKEN } from '../../shared/constants/cookies-name.constant';
import { AuthTokenService } from '../../services/authToken.service';
import { CookieService } from '../../services/cookie.service';
import { BankAccount, ProfileData } from './shared/models/profile-result.model';
export class ConfirmationFormComponent implements OnInit, OnDestroy {
   statusCancelCb = new EventEmitter<string>();
public loanData: any;
public profileData: ProfileData;
public data: any;
public xauth: any;
public workData: any;
public bankData: BankAccount;
public CONFIRMATION_SENT: any = CONFIRMATION_SENT;
private subscription: Subscription = new Subscription();
/**
 * @param {?} confirmationFormservice
 * @param {?} workService
 * @param {?} indexService
 * @param {?} cookieService
 * @param {?} authTokenService
 */
constructor(
public confirmationFormservice: ConfirmationFormService,
public workService: ConfirmationWorkPlaceService,
public indexService: ConfirmationIndexService,
private cookieService: CookieService,
private authTokenService: AuthTokenService,
  ) {
    this.subscription.add(
      this.confirmationFormservice.dataStore.subscribe(res => {
        this.data = res;
      }),
    );

    this.subscription.add(
      this.workService.dataStore.subscribe(res => {
        this.workData = res.workPlaceForm;
        this.confirmationFormservice.setStore({ workData: this.workData });
      }),
    );
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    const /** @type {?} */ token = this.cookieService.get(TNK_TOKEN);
    const /** @type {?} */ authToken = this.authTokenService.getAuthToken(token);

    this.subscription.add(
      this.workService.getProfileData(authToken).subscribe(x => {
        this.workService.buildForm();
      }),
    );

    this.setBankData();

    this.confirmationFormservice.setStore({
      loanData: this.loanData,
      workData: this.workData,
      bankData: this.bankData,
      profile: authToken,
    });
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.confirmationFormservice.setStore({ step: 0 });
    this.subscription.unsubscribe();
    this.workService.subscription.unsubscribe();
  }
/**
 * @param {?} param
 * @return {?}
 */
statusCancelFromChildren(param: string): void {
    this.statusCancelCb.emit(param);
  }
/**
 * @return {?}
 */
private setBankData(): void {
    this.bankData = this.profileData.newLoanInfo.account;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tnk-confirmation-form',
  template: `
    <ng-container>
      <ng-container
        *ngIf="data.step == 0 && loanData.applicationStatus === CONFIRMATION_SENT"
      >
        <confirmation-confirmed></confirmation-confirmed>
      </ng-container>

      <ng-container
        *ngIf="data.step == 0 && loanData.applicationStatus !== CONFIRMATION_SENT"
      >
        <confirmation-index
          [profile]="data.profile"
          [loan]="loanData"
          (statusCancelCb)="statusCancelFromChildren($event)"
        ></confirmation-index>
      </ng-container>

      <ng-container *ngIf="data.step == 1">
        <confirmation-work-place></confirmation-work-place>
      </ng-container>

      <ng-container *ngIf="data.step == 2">
        <confirmation-bank-account
          [bankData]="data.bankData"
        ></confirmation-bank-account>
      </ng-container>

      <ng-container *ngIf="data.step == 3">
        <confirmation-pin-picture
          [profile]="data.profile"
          [loan]="loanData"
        ></confirmation-pin-picture>
      </ng-container>

      <ng-container *ngIf="data.step == 4">
        <confirmation-selfie-picture
          [profile]="data.profile"
          [loan]="loanData"
        ></confirmation-selfie-picture>

        <tnk-modal [isOpen]="data.modal == data.consts.MODAL_SUCCESS">
          <tnk-modal-body class="tnk-align--center">
            <h5 class="tnk-color--secondary">
              Formulir Konfirmasi Anda sudah terkirim!
            </h5>
            <p>
              Terima kasih telah mengirimkan formulir konfirmasi. Status pinjaman
              Anda akan diperbaharui setelah Anda menerima notifikasi SMS dan email
              draft kontrak.
            </p>
          </tnk-modal-body>
          <tnk-modal-footer>
            <button
              class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
              (click)="confirmationFormservice.closeSuccessModal()"
            >
              Saya Mengerti
            </button>
          </tnk-modal-footer>
        </tnk-modal>

        <tnk-modal [isOpen]="data.modal == data.consts.MODAL_FAILED">
          <tnk-modal-body class="tnk-align--center">
            <h5 class="tnk-color--secondary">Maaf terjadi kesalahan</h5>
            <p>Terjadi kesalahan. Silahkan cek kembali form Anda.</p>
          </tnk-modal-body>
          <tnk-modal-footer>
            <button
              class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
              (click)="confirmationFormservice.closeModal()"
            >
              Saya Mengerti
            </button>
          </tnk-modal-footer>
        </tnk-modal>

        <tnk-modal [isOpen]="data.modal == data.consts.MODAL_ERROR">
          <tnk-modal-body class="tnk-align--center">
            <h5 class="tnk-color--secondary">
              Mohon maaf terdapat kesalahan dengan sistem kami
            </h5>
            <p>
              Mohon maaf terjadi masalah server. Silakan coba beberapa saat lagi.
            </p>
          </tnk-modal-body>
          <tnk-modal-footer>
            <button
              class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
              (click)="confirmationFormservice.closeModal()"
            >
              Saya Mengerti
            </button>
          </tnk-modal-footer>
        </tnk-modal>
      </ng-container>
    </ng-container>
  `,
  styles: [`
    .tnk-card {
      background: #fdfdfd;
      border-left: 5px solid #ffc412;
      border-radius: 5px;
      color: #535353;
      margin-bottom: 15px; }
      .tnk-card__nav {
        margin: 15px 0; }
      .tnk-card__header {
        border-bottom: 1px solid #e1e1e1;
        padding: 15px;
        -ms-flex-flow: wrap;
            flex-flow: wrap; }
        .tnk-card__header h1 {
          font-size: 16px;
          margin: 0;
          width: 100%; }
        .tnk-card__header small {
          font-size: 12px;
          color: #9b9b9b;
          width: 100%; }
      .tnk-card__body {
        padding: 10px 0; }
        .tnk-card__body .exampling-container__item {
          background: #f4f4f4;
          border-radius: 10px;
          padding: 10px;
          margin: 5px 0 15px 0;
          text-align: center; }
          .tnk-card__body .exampling-container__item-row {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                -ms-flex-direction: row;
                    flex-direction: row;
            justify-items: center;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            margin: 0 auto; }
          .tnk-card__body .exampling-container__item .img-padding {
            padding: 4px; }
          .tnk-card__body .exampling-container__item .exampling-img {
            margin: 5px 0 10px 0; }
            .tnk-card__body .exampling-container__item .exampling-img.text-red {
              color: #ff0000; }
            .tnk-card__body .exampling-container__item .exampling-img.text-green {
              color: #80bd01; }
            .tnk-card__body .exampling-container__item .exampling-img img {
              margin: 0 auto;
              height: 100px; }
            .tnk-card__body .exampling-container__item .exampling-img h4 {
              margin: 5px 0;
              font-size: 12px;
              font-weight: bolder; }
          .tnk-card__body .exampling-container__item h2 {
            font-size: 14px;
            margin: 0 0 10px 0;
            text-align: center;
            font-weight: bolder; }
          .tnk-card__body .exampling-container__item small {
            font-size: 12px;
            margin: 5px 0; }
        .tnk-card__body .exampling-container__preview img {
          max-width: 150px; }
        .tnk-card__body .exampling-container__error p {
          color: #ff0000;
          padding-bottom: 10px; }
        .tnk-card__body .cancel-content form div {
          margin: 15px 0; }
        .tnk-card__body .form-group p {
          font-size: 12px;
          margin: -7px 0 4px 0; }
        .tnk-card__body h1 {
          margin: 0;
          font-size: 16px;
          font-weight: bolder;
          line-height: 21px; }
        .tnk-card__body h4 {
          margin: 0;
          font-size: 12px; }
        .tnk-card__body ul {
          padding: 0;
          margin: 0; }
          .tnk-card__body ul li:not(.tnk-li) {
            list-style-type: none; }
        .tnk-card__body ul.tnk-ul {
          margin-left: 15px; }
        .tnk-card__body strong {
          font-weight: bolder; }
        .tnk-card__body p {
          font-size: 14px;
          line-height: 21px; }
        .tnk-card__body p.tnk-confirmation--p {
          font-size: 16px; }
        .tnk-card__body small {
          font-size: 12px; }

    .p-t {
      padding-top: 10px; }

    .p-b {
      padding-bottom: 10px; }

    .p-y {
      padding: 5px 0px; }

    .p-x {
      padding: 0px 5px; }

    .tnk-button__blue {
      width: 120px;
      color: #0087c6;
      background-color: #fdfdfd;
      border: 2.5px solid #0087c6;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__blue.active {
        color: #fdfdfd;
        background-color: #0087c6; }
      .tnk-button__blue.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__blue.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }

    .tnk-button__green {
      width: 120px;
      color: #80bd01;
      background-color: #fdfdfd;
      border: 2.5px solid #80bd01;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__green.active {
        color: #fdfdfd;
        background-color: #80bd01; }
      .tnk-button__green.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__green.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }
      .tnk-button__green.right {
        float: right; }

    .info-card {
      width: 100%;
      background-color: #fffcdb; }

    .info-card--mobile-view {
      display: none; }

    .info-card--desktop-view {
      display: inline; }

    @media (max-width: 768px) {
      .info-card--mobile-view {
        display: inline; }
      .info-card--desktop-view {
        display: none; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfirmationFormService, },
{type: ConfirmationWorkPlaceService, },
{type: ConfirmationIndexService, },
{type: CookieService, },
{type: AuthTokenService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'statusCancelCb': [{ type: Output },],
'loanData': [{ type: Input },],
'profileData': [{ type: Input },],
};
}

function ConfirmationFormComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationFormComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationFormComponent.ctorParameters;
/** @type {?} */
ConfirmationFormComponent.propDecorators;
/** @type {?} */
ConfirmationFormComponent.prototype.statusCancelCb;
/** @type {?} */
ConfirmationFormComponent.prototype.loanData;
/** @type {?} */
ConfirmationFormComponent.prototype.profileData;
/** @type {?} */
ConfirmationFormComponent.prototype.data;
/** @type {?} */
ConfirmationFormComponent.prototype.xauth;
/** @type {?} */
ConfirmationFormComponent.prototype.workData;
/** @type {?} */
ConfirmationFormComponent.prototype.bankData;
/** @type {?} */
ConfirmationFormComponent.prototype.CONFIRMATION_SENT;
/** @type {?} */
ConfirmationFormComponent.prototype.subscription;
/** @type {?} */
ConfirmationFormComponent.prototype.confirmationFormservice;
/** @type {?} */
ConfirmationFormComponent.prototype.workService;
/** @type {?} */
ConfirmationFormComponent.prototype.indexService;
/** @type {?} */
ConfirmationFormComponent.prototype.cookieService;
/** @type {?} */
ConfirmationFormComponent.prototype.authTokenService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
